import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _116918b0 = () => interopDefault(import('../../../pages/contacto/index.vue' /* webpackChunkName: "pages/contacto/index" */))
const _270656f0 = () => interopDefault(import('../../../pages/contacto-pro/index.vue' /* webpackChunkName: "pages/contacto-pro/index" */))
const _11edec6d = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/index.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/index" */))
const _01d231b4 = () => interopDefault(import('../../../pages/contacto-pro/confirmado.vue' /* webpackChunkName: "pages/contacto-pro/confirmado" */))
const _0e2ebc06 = () => interopDefault(import('../../../pages/contacto/confirmado.vue' /* webpackChunkName: "pages/contacto/confirmado" */))
const _33d77ebd = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/calentador-de-agua-solar.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/calentador-de-agua-solar" */))
const _79d75210 = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/energia-solar.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/energia-solar" */))
const _709236ef = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/panel-termico-solar.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/panel-termico-solar" */))
const _4a7fa8ba = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/paneles-fotovoltaicos.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/paneles-fotovoltaicos" */))
const _de914b4c = () => interopDefault(import('../../../pages/informacion-sobre-paneles-solares/subsidios.vue' /* webpackChunkName: "pages/informacion-sobre-paneles-solares/subsidios" */))
const _32029e0a = () => interopDefault(import('../../../pages/solicitudes-de-cotizacion/introduce-tus-datos.vue' /* webpackChunkName: "pages/solicitudes-de-cotizacion/introduce-tus-datos" */))
const _209b0fe4 = () => interopDefault(import('../../../pages/solicitudes-de-cotizacion/revisa-tu-telefono.vue' /* webpackChunkName: "pages/solicitudes-de-cotizacion/revisa-tu-telefono" */))
const _6254e7bc = () => interopDefault(import('../../../pages/solicitudes-de-cotizacion/solicitud-completada.vue' /* webpackChunkName: "pages/solicitudes-de-cotizacion/solicitud-completada" */))
const _72ab4ae2 = () => interopDefault(import('../../../pages/solicitudes-de-cotizacion/tipo-de-consulta.vue' /* webpackChunkName: "pages/solicitudes-de-cotizacion/tipo-de-consulta" */))
const _caa43796 = () => interopDefault(import('../../../pages/solicitudes-de-cotizacion/tipo-tejado-consumo-energetico-anual-estimado.vue' /* webpackChunkName: "pages/solicitudes-de-cotizacion/tipo-tejado-consumo-energetico-anual-estimado" */))
const _00fa29ac = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _29331e18 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.es.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contacto",
    component: _116918b0,
    name: "contacto"
  }, {
    path: "/contacto-pro",
    component: _270656f0,
    name: "contacto-pro"
  }, {
    path: "/informacion-sobre-paneles-solares",
    component: _11edec6d,
    name: "informacion-sobre-paneles-solares"
  }, {
    path: "/contacto-pro/confirmado",
    component: _01d231b4,
    name: "contacto-pro-confirmado"
  }, {
    path: "/contacto/confirmado",
    component: _0e2ebc06,
    name: "contacto-confirmado"
  }, {
    path: "/informacion-sobre-paneles-solares/calentador-de-agua-solar",
    component: _33d77ebd,
    name: "informacion-sobre-paneles-solares-calentador-de-agua-solar"
  }, {
    path: "/informacion-sobre-paneles-solares/energia-solar",
    component: _79d75210,
    name: "informacion-sobre-paneles-solares-energia-solar"
  }, {
    path: "/informacion-sobre-paneles-solares/panel-termico-solar",
    component: _709236ef,
    name: "informacion-sobre-paneles-solares-panel-termico-solar"
  }, {
    path: "/informacion-sobre-paneles-solares/paneles-fotovoltaicos",
    component: _4a7fa8ba,
    name: "informacion-sobre-paneles-solares-paneles-fotovoltaicos"
  }, {
    path: "/informacion-sobre-paneles-solares/subsidios",
    component: _de914b4c,
    name: "informacion-sobre-paneles-solares-subsidios"
  }, {
    path: "/solicitudes-de-cotizacion/introduce-tus-datos",
    component: _32029e0a,
    name: "solicitudes-de-cotizacion-introduce-tus-datos"
  }, {
    path: "/solicitudes-de-cotizacion/revisa-tu-telefono",
    component: _209b0fe4,
    name: "solicitudes-de-cotizacion-revisa-tu-telefono"
  }, {
    path: "/solicitudes-de-cotizacion/solicitud-completada",
    component: _6254e7bc,
    name: "solicitudes-de-cotizacion-solicitud-completada"
  }, {
    path: "/solicitudes-de-cotizacion/tipo-de-consulta",
    component: _72ab4ae2,
    name: "solicitudes-de-cotizacion-tipo-de-consulta"
  }, {
    path: "/solicitudes-de-cotizacion/tipo-tejado-consumo-energetico-anual-estimado",
    component: _caa43796,
    name: "solicitudes-de-cotizacion-tipo-tejado-consumo-energetico-anual-estimado"
  }, {
    path: "/",
    component: _00fa29ac,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/declaracion-de-privacidad",
    component: _861e7d2c,
    name: "declaracion-de-privacidad"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/condiciones-generales",
    component: _29331e18,
    name: "condiciones-generales"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
